// extracted by mini-css-extract-plugin
export var messageSideLeft = "_og-1";
export var messageSideRight = "_og-2";
export var subscribeToBackInStockBubbleContainer = "_og-0";